(ns app.front.view.bond.view
  (:require [app.domain.bond.model :as bond-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.view.bond.common :as bond-common]
            [app.front.view.bond.subs :as bond-subs]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [re-frame.std-interceptors :as interceptors]
            [schema.core :as s]))

(def ^:private state-path (interceptors/path ::state))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::bond-loading?
  :<- [::state]
  :-> :bond-loading?)

(rf/reg-event-fx ::fetch-bond
  [state-path]
  (fn [{state :db} [_ bond-id]]
    {:comm/command {:command    :bond/get-bond
                    :method     :get
                    :data       (util/mmap bond-id)
                    :on-success [::fetch-bond.success]}
     :db           (assoc state :bond-loading? true :bond-id bond-id)}))

(rf/reg-event-fx ::fetch-bond.success
  [state-path]
  (fn [{state :db} [_ status entities]]
    {:fx [[:dispatch [::entities/merge-entity-db status entities]]
          [:dispatch [::bond-common/sync-workspace-attachment-types]]]
     :db (assoc state :bond-loading? false)}))

(rf/reg-sub ::back-href
  :<- [:route/match]
  :<- [::href/branded-href :dashboard]
  (fn [[match dashboard-href] _]
    (let [{:keys [wizard workspace]} (-> match :parameters :query)]
      (if (and wizard workspace)
        (href/href :view/application-wizard-workspace
                   {:workspace-id workspace
                    :step         "summary"})
        dashboard-href))))

(rf/reg-sub ::view-data
  :<- [::back-href]
  (fn [back-href]
    {:back-href back-href}))

(defn- breadcrumb [{:keys [match]}]
  (let [{:keys [bond-id]
         :as   params}   (-> match :parameters :path)
        bond             (<sub [::entities/entity {:bond/id bond-id}])]
    [(-> match :data :name) params (bond-model/bond-identifier bond)]))

(defn view [{{{:keys [bond-id]} :path} :parameters
             :as                       match}]
  (let [tr                 (<sub [:tr])
        bond-loading?      (<sub [::bond-loading?])
        bond               (<sub [::bond-subs/bond {:bond/id bond-id}])
        full-edit?         (<sub [::bond-subs/edit-full?])
        edit-open?         (<sub [::bond-subs/edit-open?])
        in-full-edit-mode? (and edit-open? full-edit?)]
    [:div.cloudpermit-page
     [ui/page-header (util/mmap match)
      [:div.px-8
       [:h2 (if in-full-edit-mode?
              (tr [:bond/edit])
              (tr [:bond/bond]))]]]
     (cond
       bond-loading?
       [section/section-skeleton]

       in-full-edit-mode?
       [bond-common/full-edit-form bond tr {:wrapper :section.flex.flex-col.w-full}]

       :else
       [bond-common/bond-view bond tr])]))

(def base-route
  {:name        :view/bond.base
   :view        view
   :view-sub    [::view-data]
   :parameters  {:path  {:bond-id s/Str}
                 :query {(s/optional-key :wizard)    s/Bool
                         (s/optional-key :workspace) s/Str}}
   :breadcrumb  {:items [breadcrumb]}
   :controllers [{:parameters {:path [:bond-id]}
                  :start      (fn [{{:keys [bond-id]} :path}]
                                (>evt [::fetch-bond bond-id])
                                (>evt [::bond-common/fetch-related-workspaces bond-id]))}]})
